import type { CommentBodyMentionProps } from '@liveblocks/react-ui/primitives'

import { MentionChip } from './mention-chip'
import { UserName } from './user-name'

export const CommentMention = ({ mention }: CommentBodyMentionProps) => (
  <MentionChip label={<UserName userId={mention.id} />} tooltip={mention.id} />
)
